import Vue from 'vue';

export const onConsentUpdate = (consentData) => {
    // Push the consent update command to the dataLayer
    Vue.$gtm.gtag('consent', 'update', consentData);
    console.log('Consent Update:', consentData);
};
